import React, {useState} from "react";
import {Button, Form, Input, message, Modal,Select} from "antd";
import {getHostAddress,getFrontEndAddress} from "../../Tool/UtileFun"

export function ButtonAndModal(props){

    const [modalStatus,setModalStatus] = useState(false);
    const [classInfo,setClassInfo] = useState([]);


    const findAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/cclass/findAll",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify("{}"),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setClassInfo(data)
            })
            .catch(error => message.error("error"+error));
    }

    const updateUser=(classId)=>{
        fetch(
            "http://"+getHostAddress()+"/user/userUpdate",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({userId:props.props.id,classId:classId}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setClassInfo(data)
            })
            .catch(error => message.error("error"+error));
    }

    const handleCancel = e => {
        console.log(e);
        setModalStatus(false)
    };

    const showModal = e => {
        findAll()
        console.log(e);
        setModalStatus(true)
    };


    const handleOk = e => {
        setModalStatus(false)
        updateUserClass()
        RefreshTable()
    };

    const updateUserClass=()=>{
        if (selectValue === "" || selectValue === null || selectValue === undefined){
            console.log(selectValue)
            message.warning("没拿到退出了")
            return
        }
        updateUser(selectValue)
    }

    const RefreshTable = () =>{
        setTimeout(function () {
            props.Event()
        }, 100);
    }


    let selectValue
    const handleChange=(value)=> {
        selectValue = value
        console.log(`selected ${value}`);
    }

    const isRole=()=>{
        if (props.props.role === "student"){
            return "学生"
        }
        if (props.props.role === "teacher"){
            return "老师"
        }
        if (props.props.role === "admin"){
            return "管理员"
        }
    }
    const { Option } = Select;
    const from = (
        <Form>
            <Form.Item label="学号"
                       name="studentNumber"
            >
                <Input placeholder={props.props.studentNumber} disabled/>
            </Form.Item>
            <Form.Item label="姓名"
                       name="name"
            >
                <Input placeholder={props.props.realName} disabled/>
            </Form.Item>
            <Form.Item label="角色"
                       name="role"
            >
                <Input placeholder={isRole()} disabled/>
            </Form.Item>
            <Form.Item label="电话"
                       name="studentNumber"
            >
                <Input placeholder={props.props.telNumber} disabled/>
            </Form.Item>
            <Form.Item label="班级"
                       name="className"
            >
                <Select
                    defaultValue={props.props.className}
                    style={{ width: 120 }}
                    onChange={handleChange}
                >
                    {
                        classInfo.map(
                            ci=><Option key={ci.id}>{ci.className}</Option>
                        )
                    }
                </Select>
            </Form.Item>
        </Form>
    )


    return(
        <>
            <Button type="primary" onClick={showModal}>编辑</Button>
            <Modal
                title="编辑班级"
                visible={modalStatus}
                onOk={handleOk}
                onCancel={handleCancel}
                okText={"确定"}
                cancelText={"取消"}
            >
                {from}
            </Modal>
        </>
    )
}
